import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/donate',
      name: 'donate',
      component: () => import(/* webpackChunkName: "about" */ './views/donate.page')
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      component: () => import(/* webpackChunkName: "about" */ './views/register.page')
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: () => import(/* webpackChunkName: "about" */ './views/sign-in.page')
    },

    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import(/* webpackChunkName: "about" */ './views/reset-password.page')
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import(/* webpackChunkName: "pricing" */ './views/pricing.page')
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import(/* webpackChunkName: "about" */ './views/terms.page')
    },
    {
      path: '/docs',
      name: 'docs',
      component: () => import(/* webpackChunkName: "docs" */ './views/documentation/docs.page'),
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "docs" */ './views/documentation/quick-start.page'),
        },
        {
          path: 'configuration-file',
          component: () => import(/* webpackChunkName: "docs" */ './views/documentation/configuration-file.page'),
        },
        {
          path: 'django-support',
          component: () => import(/* webpackChunkName: "docs" */ './views/documentation/django-support.page'),
        },
        {
          path: 'variables-tracing',
          component: () => import(/* webpackChunkName: "docs" */ './views/documentation/trace-variables.page'),
        },
        {
          path: 'debugging-support',
          component: () => import(/* webpackChunkName: "docs" */ './views/documentation/debugging-support.page'),
        },
        {
          path: 'faq',
          component: () => import(/* webpackChunkName: "docs" */ './views/documentation/faq.page'),
        },
      ]
    },
    {
      path: '/new-password',
      name: 'new-password',
      component: () => import(/* webpackChunkName: "about" */ './views/new-password.page')
    },

    {
      path: '/my-profile',
      name: 'my-profile',
      component: () => import(/* webpackChunkName: "about" */ './views/my-profile.page')
    }
  ],
})
